module.exports = __webpack_public_path__ + "img/cell-phones-on-shelf-in-telecommunication-shop.1b3e4391.jpg";